import { useLanguage } from "../../Components/LangTranslation/LanguageContext";

const ButtonList = () => {
  const { language, translations } = useLanguage();
  const t = translations[language];

  const buttonList = [
    { dataId: 101, name: t["Subscription"] },
    { dataId: 102, name: t["My Company"] },
    { dataId: 103, name: t["Connect Social Media"] },
    { dataId: 104, name: t["Orders"] },
    { dataId: 105, name: t["Contacts"] },
    { dataId: 106, name: t["CRM"] },
    { dataId: 107, name: t["Product"] },
    { dataId: 108, name: t["Design Your Website"] },
    { dataId: 109, name: t["Coupon Programs"] },
    { dataId: 110, name: t["Promotion Programs"] },
    { dataId: 111, name: t["Legacy System"] },
  ];

  return buttonList;
};

export default ButtonList;
